/*
  Fem Butor Shop - varians-kapu

  Cel: a termekoldalon ne legyen elore kivalasztott varians. A vevonek
  mindegyik opciot magatol kell megadnia, es addig ne tudjon kosarba tenni.

  Miert nem eleg egyszer torolni a bejelolest:
  a Dawn minden variansvaltasnal ujrarendereli a szekciot, kicsereli a
  teljes <variant-selects> elemet, es az altala feloldott varians opcioit
  ujra bejeloli. Ezert nem a DOM allapotara tamaszkodunk, hanem kulon
  nyilvantartjuk, melyik opciot kattintotta meg tenylegesen a vevo
  (data-option-name alapjan). Ami nincs a listaban, azt minden
  ujrarenderelas utan visszatoroljuk.

  Feloldas: amint minden opciocsoportbol van vevoi valasztas, visszaadjuk
  az eredeti gombfeliratot es allapotot, es tobbe nem nyulunk semmihez -
  innentol a Dawn (es a Zakeke) kezeli a gombot.
*/
(function () {
  'use strict';

  var PROMPT = 'Válaszd ki a paramétereket';
  var RAL_PROMPT = 'Add meg a RAL kódot';
  var NAME_PROMPT = 'Add meg a nevet';
  var MOUNT_PROMPT = 'Válaszd ki a rögzítést';
  var ZAKEKE_LABEL = 'Tervezd meg a sajátodat';
  var PLACEHOLDER = 'Válassz…';

  var picks = {}; // sectionId -> { optionName: true }
  var released = {}; // sectionId -> true
  var originals = {}; // sectionId -> { label, disabled, hiddenDisabled }
  var expected = {}; // sectionId -> [opcionevek a betolteskori DOM-bol]
  var ralValues = {}; // sectionId -> a beirt RAL kod (ujrarenderelest tulel)
  var nameValues = {}; // sectionId -> a beirt nev (ujrarenderelest tulel)
  var mountValues = {}; // sectionId -> a valasztott rogzites (ujrarenderelest tulel)
  var scheduled = false;

  /*
    FONTOS: ezt csak egyszer, betolteskor szabad kiertekelni.
    A Dawn variansvaltaskor hozzafuzi a ?variant=... parametert az
    URL-hez (history.replaceState). Ha minden futasnal ujra neznenk,
    az elso valasztas utan melyliknek hinnenk az oldalt, es a kapu
    csendben leallna.
  */
  var deepLinked = new URLSearchParams(window.location.search).has('variant');

  function optionNameOf(input) {
    return input.getAttribute('data-option-name') || input.name || '';
  }

  function groupNames(picker) {
    var names = [];
    picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var n = optionNameOf(input);
      if (n && names.indexOf(n) === -1) names.push(n);
    });
    picker.querySelectorAll('select').forEach(function (select) {
      var n = select.name || select.id;
      if (n && names.indexOf(n) === -1) names.push(n);
    });
    return names;
  }

  function formOf(sectionId) {
    return document.getElementById('product-form-' + sectionId);
  }

  function remember(sectionId, form) {
    if (originals[sectionId]) return;
    var submit = form.querySelector('button[name="add"]');
    var span = submit ? submit.querySelector('span') : null;
    var hidden = form.querySelector('input.product-variant-id');
    originals[sectionId] = {
      label: span ? span.textContent : null,
      disabled: submit ? submit.disabled : false,
      hiddenDisabled: hidden ? hidden.disabled : false
    };
  }

  // A vevo altal NEM valasztott opciok bejeloleset visszavonjuk.
  function stripUnpicked(picker, chosen) {
    picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.checked && !chosen[optionNameOf(input)]) input.checked = false;
    });

    picker.querySelectorAll('select').forEach(function (select) {
      var n = select.name || select.id;
      if (chosen[n]) return;
      if (!select.querySelector('option[data-gate-placeholder]')) {
        var option = document.createElement('option');
        option.value = '';
        option.textContent = PLACEHOLDER;
        option.setAttribute('data-gate-placeholder', '');
        select.insertBefore(option, select.firstChild);
      }
      if (select.value) select.value = '';
    });

    picker.querySelectorAll('[data-selected-value]').forEach(function (el) {
      if (el.textContent.trim() !== '') el.textContent = '';
    });
  }

  /*
    Ha egy korabban valasztott ertek a jelenlegi kombinacioban mar nem
    elerheto - pl. a vevo Feketet valasztott, majd atvaltott rozsdamentes
    acelra, amit nem festunk -, akkor azt a valasztast eldobjuk. A vevonek
    ujra kell valasztania, addig pedig a kapu ismet zar.
  */
  function dropUnavailablePicks(picker, sectionId, chosen) {
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (el) {
      var name = optionNameOf(el);
      if (!chosen[name]) return;
      if (!el.classList.contains('visually-disabled') && !el.classList.contains('disabled')) return;
      delete chosen[name];
      el.checked = false;
      released[sectionId] = false;
    });
  }

  function gate(picker, sectionId, form) {
    var chosen = picks[sectionId] || (picks[sectionId] = {});
    dropUnavailablePicks(picker, sectionId, chosen);
    if (released[sectionId]) return;

    // Az opciocsoportokat a betolteskori, stabil DOM-bol rogzitjuk.
    // Ujrarenderelés kozben a picker atmenetileg kevesebb csoportot
    // tartalmazhat - ha abbol szamolnank, a kapu korán feloldana.
    if (!expected[sectionId]) {
      var found = groupNames(picker);
      if (!found.length) return;
      expected[sectionId] = found;
    }

    var names = expected[sectionId];
    var complete = names.every(function (n) {
      return chosen[n];
    });

    var submit = form.querySelector('button[name="add"]');
    var span = submit ? submit.querySelector('span') : null;
    var hidden = form.querySelector('input.product-variant-id');
    var payment = form.querySelector('.shopify-payment-button');
    // A Zakeke a sajat gombjat teszi a nativ helyere; amig nincs meg
    // minden valasztas, azt is elrejtjuk, kulonben a vevo egy tiltott
    // "Out of Stock" gombot lat.
    // A nev-mezos termekeknel (eremakasztok) viszont egyaltalan nincs
    // Zakeke: ott a suppressZakeke() tartja elrejtve a gombot, a
    // kapunak nem kell vele szamolnia.
    var zakeke = nameWrap(sectionId) ? null : document.getElementById('zakeke-product-button');

    if (complete) {
      released[sectionId] = true;
      var orig = originals[sectionId];
      if (submit) submit.disabled = orig.disabled;
      if (span && orig.label !== null) span.textContent = orig.label;
      if (hidden) hidden.disabled = orig.hiddenDisabled;
      // Ha a Zakeke elrejtette a nativ gombot, es mi ideiglenesen
      // visszahoztuk, most visszaadjuk neki a terepet.
      if (submit && submit.hasAttribute('data-gate-unhidden')) {
        submit.removeAttribute('data-gate-unhidden');
        if (zakeke) submit.style.display = 'none';
      }
      [payment, zakeke].forEach(function (el) {
        if (el && el.hasAttribute('data-gate-hidden')) {
          el.removeAttribute('data-gate-hidden');
          el.style.display = '';
        }
      });
      return;
    }

    stripUnpicked(picker, chosen);

    if (submit && !submit.disabled) submit.disabled = true;
    if (span && span.textContent.trim() !== PROMPT) span.textContent = PROMPT;
    // A Zakeke elrejti a nativ gombot, es a sajatjat teszi a helyere.
    // Amig nincs kesz a valasztas, a Zakeke gombjat elrejtjuk - ezert
    // a nativ gombot elo kell hoznunk, kulonben a vevo egyetlen
    // kattinthato elemet sem lat, csak egy ures helyet.
    if (submit && submit.style.display === 'none') {
      submit.setAttribute('data-gate-unhidden', '');
      submit.style.display = '';
    }
    if (hidden && !hidden.disabled) hidden.disabled = true;
    [payment, zakeke].forEach(function (el) {
      if (el && !el.hasAttribute('data-gate-hidden')) {
        el.setAttribute('data-gate-hidden', '');
        el.style.display = 'none';
      }
    });
  }

  /* ---------------- RAL szinkod mezo ---------------- */

  function ralWrap(sectionId) {
    return document.querySelector('[data-fbs-ral="' + sectionId + '"]');
  }

  // Akkor kell a mezo, ha a kivalasztott szinopcio neveben szerepel
  // a wrap data-fbs-ral-match erteke (alapban: "megjegyz").
  function ralNeeded(picker, wrap) {
    var match = (wrap.getAttribute('data-fbs-ral-match') || '').toLowerCase();
    if (!match) return false;
    var needed = false;
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
      if ((input.value || '').toLowerCase().indexOf(match) !== -1) needed = true;
    });
    return needed;
  }

  function syncRal(sectionId, picker) {
    var wrap = ralWrap(sectionId);
    if (!wrap) return;
    var input = wrap.querySelector('[data-fbs-ral-input]');
    if (!input) return;

    if (ralNeeded(picker, wrap)) {
      if (wrap.hasAttribute('hidden')) wrap.removeAttribute('hidden');
      if (input.disabled) input.disabled = false;
      // A Dawn ujrarendereli a szekciot, ilyenkor a mezo uresen jon
      // vissza - visszaallitjuk, amit a vevo mar beirt.
      var stored = ralValues[sectionId];
      if (stored && input.value !== stored) input.value = stored;
    } else {
      if (!wrap.hasAttribute('hidden')) wrap.setAttribute('hidden', '');
      // Tiltva nem kerul be a rendelesbe line item property-kent.
      if (!input.disabled) input.disabled = true;
      if (input.value) input.value = '';
      delete ralValues[sectionId];
      wrap.classList.remove('fbs-ral--invalid');
    }
  }

  function ralBlocking(sectionId) {
    var wrap = ralWrap(sectionId);
    if (!wrap || wrap.hasAttribute('hidden')) return false;
    var input = wrap.querySelector('[data-fbs-ral-input]');
    return !input || !/^\d{4}$/.test(input.value);
  }

  /* ---------------- Nev-mezo (eremakasztok) ---------------- */

  function nameWrap(sectionId) {
    return document.querySelector('[data-fbs-name="' + sectionId + '"]');
  }

  function nameBlocking(sectionId) {
    var wrap = nameWrap(sectionId);
    if (!wrap) return false;
    var input = wrap.querySelector('[data-fbs-name-input]');
    return !input || input.value.trim() === '';
  }

  // A Dawn ujrarenderelese kiuriti a mezot - visszairjuk, amit a vevo
  // mar begepelt.
  function syncName(sectionId) {
    var wrap = nameWrap(sectionId);
    if (!wrap) return;
    var input = wrap.querySelector('[data-fbs-name-input]');
    if (!input) return;
    var stored = nameValues[sectionId];
    if (stored && input.value !== stored) input.value = stored;
  }

  /* ---------------- Rogzitesi tipus (hazszamtablak) ---------------- */

  function mountWrap(sectionId) {
    return document.querySelector('[data-fbs-mount="' + sectionId + '"]');
  }

  function mountBlocking(sectionId) {
    var wrap = mountWrap(sectionId);
    if (!wrap) return false;
    return !wrap.querySelector('[data-fbs-mount-input]:checked');
  }

  // A Dawn ujrarenderelese torli a bejelolest - visszaallitjuk, amit a
  // vevo mar valasztott.
  function syncMount(sectionId) {
    var wrap = mountWrap(sectionId);
    if (!wrap) return;
    var stored = mountValues[sectionId];
    if (!stored) return;
    if (wrap.querySelector('[data-fbs-mount-input]:checked')) return;
    wrap.querySelectorAll('[data-fbs-mount-input]').forEach(function (input) {
      if (input.value === stored) input.checked = true;
    });
  }

  /*
    Eremakasztok: itt nincs Zakeke testreszabo, a vevo a nev-mezobe irja
    be a feliratot. A Zakeke viszont minden termekoldalra kiteheti a
    sajat gombjat ("szabása"), es elrejti mellette a nativ kosargombot -
    ezt forditjuk vissza.

    Nem egyszeri javitas: a Zakeke scriptje kesobb is lefuthat, ezert a
    run() minden korben ujra ervenyesiti. A fizetes-gombhoz csak akkor
    nyulunk, ha nem a kapu rejtette el (data-gate-hidden).
  */
  function suppressZakeke(form) {
    var zakeke = document.getElementById('zakeke-product-button');
    if (zakeke && zakeke.style.display !== 'none') zakeke.style.display = 'none';

    var submit = form.querySelector('button[name="add"]');
    if (submit && submit.style.display === 'none') submit.style.display = '';

    var payment = form.querySelector('.shopify-payment-button');
    if (payment && payment.style.display === 'none' && !payment.hasAttribute('data-gate-hidden')) {
      payment.style.display = '';
    }
  }

  /*
    A kiegeszito mezok miatti tiltaskor ugyanugy el kell rejteni a
    Zakeke es a gyorsfizetes gombjat, mint a valasztasi kapunal -
    kulonben a vevo a tiltott kosargomb mellett egy mukodo "tervezd
    meg" gombot lat, es a rogzites/RAL/nev megadasa nelkul indulna el.

    Sajat jelolot hasznal (data-extras-*), nem a kapu data-gate-*
    attributumat: a ketto kulon-kulon dont, es egyik sem szabad hogy
    feloldja a masik rejteset.
  */
  function extrasToggleButtons(sectionId, form, blocking) {
    var submit = form.querySelector('button[name="add"]');
    var payment = form.querySelector('.shopify-payment-button');
    // A nev-mezos termekeknel (eremakasztok) nincs Zakeke - ott a
    // suppressZakeke() tartja elrejtve a gombot.
    var zakeke = nameWrap(sectionId) ? null : document.getElementById('zakeke-product-button');

    [payment, zakeke].forEach(function (el) {
      if (!el) return;
      if (blocking) {
        // A rejtest MINDEN korben ujra ervenyesitjuk, nem csak akkor,
        // ha a jelolo meg hianyzik: a Zakeke scriptje kesobb visszairja
        // a sajat inline stilusat, es egy egyszeri beallitas elveszne.
        if (!el.hasAttribute('data-extras-hidden')) {
          el.setAttribute('data-extras-hidden', '');
        }
        if (el.style.display !== 'none') el.style.display = 'none';
        return;
      }
      if (!el.hasAttribute('data-extras-hidden')) return;
      el.removeAttribute('data-extras-hidden');
      // A kapu sajat rejtese meg ervenyben lehet - azt nem bantjuk.
      if (!el.hasAttribute('data-gate-hidden')) el.style.display = '';
    });

    // A Zakeke elrejti a nativ gombot, es a sajatjat teszi a helyere.
    // Amig mi az ovet rejtjuk, a nativot elo kell hozni, kulonben a
    // vevo egyetlen gombot sem lat.
    if (!submit || !zakeke) return;
    if (blocking) {
      // A Zakeke ujra elrejtheti, ezert minden korben ellenorizzuk.
      if (submit.style.display === 'none') {
        submit.setAttribute('data-extras-unhidden', '');
        submit.style.display = '';
      }
      return;
    }
    if (!submit.hasAttribute('data-extras-unhidden')) return;
    submit.removeAttribute('data-extras-unhidden');
    if (!submit.hasAttribute('data-gate-unhidden')) submit.style.display = 'none';
  }

  /*
    A kiegeszito mezok ellenorzese a valasztasi kapu FELOLDASA UTAN is
    aktiv marad: a vevo attehet a RAL opciora, vagy kitorolheti a nevet.
  */
  function enforceExtras(sectionId, form) {
    var ral = ralWrap(sectionId);
    var name = nameWrap(sectionId);
    var mount = mountWrap(sectionId);
    if (!ral && !name && !mount) return;

    var submit = form.querySelector('button[name="add"]');
    var span = submit ? submit.querySelector('span') : null;
    var hidden = form.querySelector('input.product-variant-id');

    var ralBad = ralBlocking(sectionId);
    var nameBad = nameBlocking(sectionId);
    var mountBad = mountBlocking(sectionId);
    var blocking = ralBad || nameBad || mountBad;
    var prompt = MOUNT_PROMPT;
    if (ralBad) prompt = RAL_PROMPT;
    else if (nameBad) prompt = NAME_PROMPT;

    if (ral) ral.classList.toggle('fbs-ral--invalid', ralBad && !ral.hasAttribute('hidden'));

    if (blocking) {
      if (submit && !submit.disabled) submit.disabled = true;
      if (hidden && !hidden.disabled) hidden.disabled = true;
      extrasToggleButtons(sectionId, form, true);
      // A feliratot csak akkor irjuk at, ha a valasztasi kapu mar
      // feloldott - kulonben az o uzenete a relevans (meg hianyzik
      // opcio), es nem akarjuk felulirni.
      if ((deepLinked || released[sectionId]) && span && span.textContent.trim() !== prompt) {
        span.textContent = prompt;
      }
      return;
    }

    // Nincs akadaly - csak akkor adjuk vissza az eredeti allapotot, ha
    // a valasztasi kapu mar feloldott (kulonben az o tiltasa ervenyes).
    if (!deepLinked && !released[sectionId]) return;
    extrasToggleButtons(sectionId, form, false);
    var orig = originals[sectionId];
    if (!orig) return;
    if (submit && submit.disabled !== orig.disabled) submit.disabled = orig.disabled;
    var current = span ? span.textContent.trim() : '';
    if (
      span &&
      orig.label !== null &&
      (current === RAL_PROMPT || current === NAME_PROMPT || current === MOUNT_PROMPT)
    ) {
      span.textContent = orig.label;
    }
    if (hidden && hidden.disabled !== orig.hiddenDisabled) hidden.disabled = orig.hiddenDisabled;
  }

  /*
    A Zakeke gombjanak felirata ket modon is rossz:
    - betolteskor beragadhat az angol "Out of Stock"-on (a zakekeLoading
      sosem vall false-ra, igy a kezdeti szoveget nem irja felul);
    - ha vegul betolt, a magyar forditasa a ertelmetlen "szabása"
      (a Zakeke automata forditasa a "Customize"-bol).
    A gomb maga mukodik - kattintasra megnyitja a testreszabot az
    /apps/zakeke utvonalon.

    Ezert minden mas feliratot atirunk a sajatunkra. A Zakeke scriptje
    kesobb is felulirhatja, ezert az observer characterData-t is figyel,
    es ilyenkor ujra lefutunk. Vegtelen ciklus nincs: ha a felirat mar
    a mienk, nem irunk.

    Csak akkor nyulunk hozza, ha a Shopify szerint a varians RENDELHETO
    (a nativ gomb nincs letiltva). Igy egy valodi keszlethianyt nem
    fedunk el.

    A vegleges megoldas a Zakeke sajat forditasi beallitasaban lenne.
  */
  function relabelZakeke(form) {
    var zakeke = document.getElementById('zakeke-product-button');
    if (!zakeke) return;
    var submit = form.querySelector('button[name="add"]');
    if (!submit || submit.disabled) return;

    if (zakeke.textContent.trim() !== ZAKEKE_LABEL) zakeke.textContent = ZAKEKE_LABEL;
  }

  function run() {
    scheduled = false;
    document.querySelectorAll('variant-selects').forEach(function (picker) {
      var sectionId = picker.dataset.section;
      if (!sectionId) return;
      var form = formOf(sectionId);
      if (!form) return;
      remember(sectionId, form);

      // Eremakasztok: Zakeke helyett nev-mezo. Meg a kapu elott fut,
      // hogy a nativ kosargomb biztosan lathato legyen. A jelolot a
      // snippet az egesz termektipusra kiteszi - az elore gyartott
      // (nem szabhato) daraboknal is, ahol nev-mezo mar nincs.
      var nameField = !!document.querySelector(
        '[data-fbs-nozakeke="' + sectionId + '"]'
      );
      if (nameField) suppressZakeke(form);

      // A RAL mezo melylinkelt oldalon is kell (pl. ha a vevo eleve a
      // RAL szinvaltozat linkjere erkezik).
      syncRal(sectionId, picker);
      syncName(sectionId);
      syncMount(sectionId);
      if (!deepLinked) gate(picker, sectionId, form);
      enforceExtras(sectionId, form);

      // A Zakeke gomb feliratat csak akkor rendezzuk, ha mar minden
      // valasztas megvan (a kapu feloldott) es a kiegeszito mezok sem
      // hianyoznak.
      if (
        !nameField &&
        (deepLinked || released[sectionId]) &&
        !ralBlocking(sectionId) &&
        !nameBlocking(sectionId) &&
        !mountBlocking(sectionId)
      ) {
        relabelZakeke(form);
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // Szandekosan setTimeout es nem requestAnimationFrame: a rAF
    // hatterben levo fulon nem fut le, igy a kapu leallna, ha a vevo
    // fulet valt a valasztas kozben.
    setTimeout(run, 0);
  }

  // Delegalt figyelo: tulel minden ujrarenderelest.
  document.addEventListener(
    'change',
    function (event) {
      var el = event.target;
      if (!el || (el.type !== 'radio' && el.tagName !== 'SELECT')) return;

      // A rogzites-mezo a <variant-selects> ELEMEN KIVUL all (a
      // product-variant-picker a zaro tag utan rendereli), ezert a
      // lenti picker-kereses eldobna. Sajat agon kezeljuk.
      if (el.hasAttribute && el.hasAttribute('data-fbs-mount-input')) {
        var mount = el.closest('[data-fbs-mount]');
        if (mount) mountValues[mount.getAttribute('data-fbs-mount')] = el.value;
        schedule();
        return;
      }

      var picker = el.closest ? el.closest('variant-selects') : null;
      if (!picker) return;
      var sectionId = picker.dataset.section;
      if (!sectionId) return;
      var name = el.type === 'radio' ? optionNameOf(el) : el.name || el.id;
      if (!name) return;
      if (el.type === 'select-one' && !el.value) return;
      (picks[sectionId] = picks[sectionId] || {})[name] = true;
      schedule();
    },
    true
  );

  // Csak szamjegy, legfeljebb negy. A beirt erteket megjegyezzuk, mert
  // a Dawn ujrarenderelese kiuritene a mezot.
  document.addEventListener('input', function (event) {
    var el = event.target;
    if (!el || !el.hasAttribute) return;

    if (el.hasAttribute('data-fbs-ral-input')) {
      var cleaned = el.value.replace(/\D+/g, '').slice(0, 4);
      if (el.value !== cleaned) el.value = cleaned;
      var ral = el.closest('[data-fbs-ral]');
      if (ral) ralValues[ral.getAttribute('data-fbs-ral')] = cleaned;
      schedule();
      return;
    }

    if (el.hasAttribute('data-fbs-name-input')) {
      var name = el.closest('[data-fbs-name]');
      if (name) nameValues[name.getAttribute('data-fbs-name')] = el.value;
      schedule();
    }
  });

  // A Dawn ujrarendereli a szekcio reszeit - minden valtozas utan
  // ujraertekelunk. A gate() csak akkor ir, ha tenylegesen valtozik
  // az ertek, igy az observer nem indit vegtelen ciklust.
  var observer = new MutationObserver(schedule);

  function start() {
    run();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      // Csak a 'disabled' erdekel: a Dawn a sajat inicializalasakor
      // visszaengedheti a gombot. Sajat irasaink feltetelesek, ezert
      // az observer nem indit vegtelen ciklust.
      // A 'style' azert kell, mert a Zakeke inline display:none-nal
      // rejti el a nativ gombot - arra is reagalnunk kell.
      attributeFilter: ['disabled', 'style'],
      // A Zakeke a sajat gombja feliratat kesobb irja be ("szabása") -
      // csak igy ertesulunk rola, hogy ujra at kell cimkezni.
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', schedule);
})();
